import React from "react";

const ScrollingTicker = () => {
  const tickerItems = [
    "Chicken Pizza",
    "Fresh Pasta",
    "Italiano French Fry",
    "Chicken Fry",
    "Crispy Burger",
    "Golden Chicken Wings",
    "Delicious Tacos",
    "Cold Beverages",
  ];

  // Double the items to make the horizontal scroll infinite and seamless
  const repeatedItems = [...tickerItems, ...tickerItems];

  return (
    <section className="bg-[#f7f5f2] py-6 overflow-hidden select-none border-y border-neutral-200/40 relative z-10">
      {/* CSS Styles for Infinite Smooth Horizontal Scrolling */}
      <style dangerouslySetInnerHTML={{__html: `
        @keyframes marquee {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
        .animate-marquee-scroll {
          display: flex;
          width: max-content;
          animation: marquee 25s linear infinite;
        }
        /* Custom hover state for pause */
        .group-hover-pause:hover .animate-marquee-scroll {
          animation-play-state: paused;
        }
      `}} />

      {/* Ticker Container with group to capture hover and pause */}
      <div className="w-full overflow-hidden flex items-center group group-hover-pause">
        <div className="animate-marquee-scroll flex items-center">
          {repeatedItems.map((item, idx) => (
            <div
              key={idx}
              className="mx-8 md:mx-12 text-2xl sm:text-3xl md:text-[38px] font-black uppercase text-neutral-400/80 transition-all duration-300 hover:text-[#e21b1b] cursor-pointer hover:underline hover:decoration-[#e21b1b] hover:decoration-4 hover:underline-offset-[12px] whitespace-nowrap"
            >
              {item}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ScrollingTicker;
